<template>
  <div class="container">
    <ModalBanner
      ref="modalBanner"
      v-on:cerrar="modalCerrado"
      v-on:creado="creado"
      v-on:editado="editado"
    />

    <div class="opciones">
      <button @click="clickNuevo()" type="button" class="btn btn-success">
        <span>Nuevo</span>
        <font-awesome-icon class="icono-derecha" :icon="Icons.AGREGAR" />
      </button>
    </div>
    <!-- Tabla -->
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col">Acción</th>
            <th>Nombre</th>
            <th>Pantalla</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="cat in banners" v-bind:key="cat.id">
            <!-- Acción -->
            <td>
              <button
                type="button"
                class="btn btn-danger"
                @click="deleteBanner(cat.id)"
              >
                <font-awesome-icon :icon="Icons.ELIMINAR" />
              </button>
            </td>
            <!-- Nombre -->
            <th scope="row">{{ cat.nombre }}</th>
            <!-- Pantalla -->
            <td>{{ cat.pantalla }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Swal from "sweetalert2";

import { Api } from "../../api";
import { Icons as IconConstants } from "../../constants";
import ModalBanner from "./modals/ModalBanner";

export default {
  components: {
    FontAwesomeIcon,

    ModalBanner,
  },
  data() {
    return {
      banners: [],
      token: "",
    };
  },
  computed: {
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    },
  },
  methods: {
    cargar() {
      Api.Banner.getTodos().then((response) => {
        this.banners = response.data;
      });
    },
    // Cuando se quiere crear un item
    clickNuevo() {
      this.$refs.modalBanner.EventoAbrir();
    },
    // Cuando se creó un item
    creado(item) {
      console.log("Banner creado " + item);
      // TODO: en vez de cargar todo, agregar a la lista existente
      this.cargar();
    },
    // Cuando se editó un item
    editado() {},
    // Cuando se cerró el modal
    modalCerrado() {},
    deleteBanner(idBanner) {
      Swal.fire({
        title: "Atención!",
        text: "Se eliminará el banner seleccionado",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Si, eliminar",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          Api.Banner.eliminar(this.token, idBanner).then(() => {
            this.cargar();
            Swal.fire(
              "Confirmación",
              "El comercio se ha eliminado con éxito",
              "success"
            );
          });
        }
      });
    },
  },
  mounted() {
    this.token = localStorage.getItem("token");

    this.cargar();
  },
};
</script>

<style scoped>
.opciones {
  margin: 15px 0px;
  width: 100%;
  display: flex;
}
.opciones > * {
  margin-right: 10px;
}
</style>
